<div
  [class]="'radius-rounded ' + wrapperCLasses()"
  (click)="handleCheck()"
  [ngStyle]="{ width: size() + 'px', height: size() + 'px' }"
></div>
